import { M_InputTextField, M_TextArea } from 'src/M_Components'

const changes = (field, value, setData) => {
    setData((prev) => ({ ...prev, [field]: value }))
}

export const CommodityFormField = ({ fields, data, setData }) => {
    if (fields.type === 'text') {
        return (
            <div style={{ margin: '5px', flex: 1, minWidth: '150px' }}>
                <M_InputTextField
                    size="100%"
                    label={fields.display}
                    value={(data && data[fields.code]) || ''}
                    required={fields.required || false}
                    color={fields.required && !data[fields.code] ? 'var(--color-red)' : undefined}
                    secondColor={fields.required && !data[fields.code] ? 'var(--color-red)' : undefined}
                    onChange={(e) => changes(fields.code, e.target.value, setData)}
                />
            </div>
        )
    }

    if (fields.type === 'textArea') {
        return (
            <div style={{ margin: '5px', flexBasis: '100%' }}>
                <M_TextArea
                    size="100%"
                    rows={2}
                    label={fields.display}
                    value={(data && data[fields.code]) || ''}
                    required={fields.required || false}
                    color={fields.required && !data[fields.code] ? 'var(--color-red)' : undefined}
                    secondColor={fields.required && !data[fields.code] ? 'var(--color-red)' : undefined}
                    onChange={(e) => changes(fields.code, e.target.value, setData)}
                />
            </div>
        )
    }

    return null
}
